<template>
  <div id="app" :class="setAdditionalsClass">
    <component :is="layout">
      <router-view :class="{'mobile-page-wrapper': is_mobile_or_tablet}" :color_theme_flag="color_theme_flag" />
    </component>
  </div>
</template>

<script>
import {
  getUserInfoByToken,
  checkIsMobileOrTablet,
  checkWindowOrientation,
  deleteLocalStorageData,
  checkSiteStatus,
  setCurrentSiteAndTariffToVuex
} from './utils/index.js'

import MainLayout from '@/layouts/MainLayout'
import WidgetLayout from '@/layouts/WidgetLayout'
import AuthorizationLayout from '@/layouts/AuthorizationLayout'
import { mapState } from 'vuex'
import i18n from '@/languages'

export default {
  name: 'App',
  components: {
    MainLayout,
    WidgetLayout,
    AuthorizationLayout
  },
  data() {
    return {
      color_theme_flag: this.$store.getters.getColorTheme
    }
  },
  beforeCreate () {
    this.$store.commit('setIsMobileOrTablet', checkIsMobileOrTablet())
    this.$store.commit('setIsPortraitOrientation', checkWindowOrientation())
    window.addEventListener('orientationchange', function () {
      this.$store.commit('setIsPortraitOrientation', checkWindowOrientation())
    }.bind(this))

    this.$store.subscribe(function (mutation, state) {
      if(mutation.type === 'setUserData' && !this.$store.getters.getSiteId) {
        if(!localStorage.getItem('lh-cp-site-id') && state.user.sites && state.user.sites.length > 0) {
          localStorage.setItem('lh-cp-site-id', state.user.sites[0].id)
          this.$store.commit('setSiteId', state.user.sites[0].id)
        }
        else {
          this.$store.commit('setSiteId', localStorage.getItem('lh-cp-site-id'))
        }

        this.$nextTick(function() {
          checkSiteStatus.call(this)
          this.setSentryUserContext()
        }.bind(this))
      }
    }.bind(this))

    if(localStorage.getItem('lh-cp-user-data')) {
      try {
        this.$store.commit('setUserData', JSON.parse(localStorage.getItem('lh-cp-user-data')))
      } catch (parse_error) {
        console.log('parse_error', parse_error)
      }
    }
    else if(!this.$store.getters.getUserData && localStorage.getItem('lh-cp-auth-token')) {
      getUserInfoByToken.call(this, localStorage.getItem('lh-cp-auth-token'))
        .then(function(response) {
          this.$store.commit('setUserData', response.data.user)
          try {
            localStorage.setItem('lh-cp-user-data', JSON.stringify(response.data.user))
          } catch (stringify_error) {
            console.log('stringify_error', stringify_error)
          }
        }.bind(this))
        .catch(function(reject) {
          console.log('Error in getUserInfoByToken: ', reject)
        })
    }

    if(!this.$store.getters.getToken && localStorage.getItem('lh-cp-auth-token')) {
      this.$store.commit('setToken', localStorage.getItem('lh-cp-auth-token'))
    }
  },
  created () {
    this.checkNeedForceRedirect()
    this.setSentryUserContext()
    this.$nextTick(function() {
      setCurrentSiteAndTariffToVuex.call(this)
    }.bind(this))
  },
  mounted () {
    this.changeBodyThemeClass(this.$store.getters.getColorTheme)
    this.$store.subscribe(function (mutation, state) {
      if(mutation.type === 'toggleColorTheme') {
        this.color_theme_flag = mutation.payload
        this.changeBodyThemeClass(mutation.payload)
      }
    }.bind(this))
  },
  computed: {
    ...mapState(['color_theme', 'language', 'is_mobile_or_tablet']),
    layout () {
      return this.$route.meta.layout || 'MainLayout'
    },
    setAdditionalsClass () {
      if(checkIsMobileOrTablet() || this.$store.getters.is_portrait_orientation) {
        if(checkIsMobileOrTablet() && this.$store.getters.is_portrait_orientation) {
          return 'mobile portrait-orientation'
        }
        else if(checkIsMobileOrTablet()) {
          return 'mobile'
        }
        else if(this.$store.getters.is_portrait_orientation) {
          return 'portrait-orientation'
        }
      }
      else {
        return ''
      }
    }
  },
  methods: {
    setPageTitle () {
      document.title = this.$route.meta.translate_route ? this.$t(this.$route.meta.translate_route) :
        this.$route.meta.title ? this.$route.meta.title : 'LeadHit'
    },
    checkNeedForceRedirect () {
      let local_storage_app_version = localStorage.getItem('lh-cp-app-version')
      if(local_storage_app_version && local_storage_app_version !== process.env.APP_VERSION && this.$store.getters.force_redirect) {
        deleteLocalStorageData()
        localStorage.setItem('lh-cp-app-version', process.env.APP_VERSION)
        window.location.reload(true)
      }
      if((!local_storage_app_version || local_storage_app_version !== process.env.APP_VERSION) && !this.$store.getters.force_redirect) {
        this.$store.commit('addNotification', {
          name: 'need_soft_redirect',
          text: 'notifications.need_soft_redirect'
        })
      }
    },
    setSentryUserContext () {
      if(!this.$raven || !this.$raven.setUserContext || !this.$raven.setExtraContext) return
      let user_context = this.$store.getters.getUserData
      if(user_context) {
        this.$raven.setUserContext()
        this.$raven.setUserContext(user_context)
      }
      this.$raven.setExtraContext()
      this.$raven.setExtraContext({site_id: this.$store.getters.getSiteId})
      this.$raven.setExtraContext({site_domain: this.$store.getters.getSiteNameById(this.$store.getters.getSiteId)})
    },
    changeBodyThemeClass (color_theme) {
      if(color_theme) {
        document.body.classList.add('color-theme-dark')
      }
      else {
        document.body.classList.remove('color-theme-dark')
      }
    }
  },
  watch: {
    '$route' () {
      this.setPageTitle()
    },
    '$i18n.locale' () {
      this.setPageTitle()
    }
  }
}
</script>

<style lang='scss'>
@import 'bootstrap/dist/css/bootstrap.css';
@import 'bootstrap-vue/dist/bootstrap-vue.css';
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400&display=swap');

.b-toaster {
  .b-toaster-slot {
    margin-top: 60px !important;

    .lh-message-toast {
      font-weight: 300;
      font-family: 'Open Sans', sans-serif;
      outline: none;

      &.lh-toast-success {
        border-color: #0CFEA1 !important;
      }

      &.lh-toast-danger {
        border-color: #ff2020 !important;
      }

      &.lh-toast-info {
        border-color: rgb(0, 163, 255) !important;
      }

      &-header {
        color: #2C3236 !important;
        padding-top: 7px !important;
        padding-bottom: 7px !important;
        border: none !important;

        &.lh-toast-success {
          background-color: #CEFFEC !important;
        }

        &.lh-toast-danger {
          background-color: #FFEAEA !important;
        }

        &.lh-toast-info {
          background: #CCEDFF !important;
        }

        button.close {
          outline: none;
          margin-bottom: 0 !important;
        }
      }

      &-body {
        display: none !important;
      }
    }
  }
}

#app {
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
}
#app.mobile {
  min-width: auto;
}
a {
  text-decoration: none;
  color: #CFD0D1;
}
a:hover {
  text-decoration: none;
  color: #CFD0D1;
}
body, html {
  margin: 0;
  height: 100%;
  width: 100%;
}
svg {
  box-sizing: unset;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}
::-webkit-scrollbar-thumb:hover {
  background: #2C3236;
}

.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
}
.main-content-wrapper {
  padding-top: 37px;
  padding-left: 19px;
  height: calc(100% - 60px);
}
.page-name {
  font-size: 22px;
}

ol.breadcrumb {
  background: transparent;
  padding-left: 0;

  .breadcrumb-item {
    font-size: 12px;

    a {
      color: black !important;
    }
  }
  .breadcrumb-item.active span{
    color: black !important;
    border-bottom: 1px solid #CFD0D1;
  }
}

.card.simple-link {
  width: 290px;
  border-radius: 0;
  border: 0;
  font-size: 14px;
  height: 220px;
  cursor: pointer;
  color: #2C3236;
  border-radius: 5px;
  padding: 0 16px;

  background: #FAFAFA;
  border: 1px solid #CFD0D1;

  .card-header {
    padding: 10px 0px;
  }
  .card-body {
    padding: 19px 0px;
    position: relative;
  }
  .card-icon {
    position: absolute;
    right: 0px;
    top: -30px;
  }
  .detailed {
    position: absolute;
    bottom: 21px;
    border: 1px solid #FF4402;
    border-radius: 3px;
    padding: 5px 20px;
    color: rgb(38, 39, 39);
  }
}

.lead-menu-hover {
  display: none;
}
.card.simple-link:hover {
  box-shadow: 4px 4px 10px rgba(95, 100, 103, 0.25);
  transition: box-shadow .3s;
  border: 1px solid #FF4402;

  .lead-menu {
    path {
      fill: #FF4402;
    }
  }
  .lead-menu-hover {
    display: block;
  }
  .lead-menu-simple {
    display: none;
  }
}

.detailed {
  border: 1px solid #FF4402;
  border-radius: 3px;
  padding: 5px 20px;
  color: rgb(38, 39, 39);
  text-decoration: none !important;
  font-size: 14px;
}
.detailed:hover {
  background: #FF4402;
  color: white !important;
}
.detailed:active {
  box-shadow: 0 0 0 0.2rem rgba(255, 68, 2, 0.5);
}
.detailed:disabled {
  color: #CFD0D1;
  border-color: #CFD0D1;
  opacity: 1;
  cursor: not-allowed;
  pointer-events: all;
}
.detailed:disabled:hover {
  background: transparent;
  color: #CFD0D1 !important;
}

.group-buttons {
  border: 1px solid #FF4402;
  border-radius: 3px;
  display: flex;

  button {
    background: transparent;
    color: #2C3236;
    border: unset;
    border-radius: 0;
  }
  button:not(:last-child) {
    border-right: 1px solid #FF4402
  }
  button:hover {
    background: #FF4402;
    color: white !important;
  }
  button:active {
    box-shadow: 0 0 0 0.2rem rgba(255, 68, 2, 0.5) !important;
    background: #FF4402 !important;
    border-color: #FF4402 !important;
  }
  button:disabled {
    color: #CFD0D1;
    opacity: 1;
    cursor: not-allowed;
    pointer-events: all;
    background: transparent;
  }
  button:disabled:hover {
    background: transparent;
    color: #CFD0D1 !important;
  }
}

input.form-control {
  background-color: transparent;
}
input.form-control:focus {
  color: #5F6467;
  background-color: transparent;
  border-color: #FF4402;
  box-shadow: 0 0 0 1px rgba(255, 68, 2, 0.5)
}

.grey-switcher {
  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    border-color: #CFD0D1 !important;
  }
  .custom-control-label::before {
    background: transparent !important;
  }
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #CFD0D1 !important;
  }
  .custom-control-input:focus ~ .custom-control-label::before {
    -webkit-box-shadow: none !important;
    box-shadow: 0 0 0 2px rgba(207, 208, 209, 0.5) !important;
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #CFD0D1 !important;
    background-color: #CFD0D1 !important;
  }
}
.custom-switch.grey-switcher .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #3F4448 !important;
}
.custom-switch.grey-switcher .custom-control-label::after {
  background: #CFD0D1 !important;
}

#slot-wrapper:not(.color-theme-dark) {

  .grey-switcher {
    .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
      border-color: #3F4448 !important;
    }
    .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
      border-color: #3F4448 !important;
    }
    .custom-control-input:focus ~ .custom-control-label::before {
      -webkit-box-shadow: none !important;
      box-shadow: 0 0 0 2px rgba(63, 68, 72, 0.7) !important;
    }
  }
  .custom-switch.grey-switcher .custom-control-label::after {
    background: #3F4448 !important;
  }
}

.custom-control.custom-switch {
  * {
    cursor: pointer;
  }
  .custom-control-input:disabled, .custom-control-input:disabled + .custom-control-label::after, .custom-control-input:disabled + .custom-control-label::before {
    cursor: auto;
  }
}

.orange-switcher {
  line-height: 24px;

  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    border-color: #FF4402 !important;
  }
  .custom-control-label::before {
    background: #FFFFFF !important;
    border-color: #FF4402 !important;
  }
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #FF4402 !important;
  }
  .custom-control-input:focus ~ .custom-control-label::before {
    -webkit-box-shadow: none !important;
    box-shadow: 0 0 0 2px rgba(255, 68, 2, 0.6) !important;
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #FF4402 !important;
    background-color: #FF4402 !important;
  }
}
.custom-switch.orange-switcher .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #FFFFFF !important;
}
.custom-switch.orange-switcher .custom-control-label::after {
  background: #FF4402 !important;
}

.orange-color {
  color: #FF4402
}
.cursor-pointer {
  cursor: pointer;
}
.font-bold {
  font-weight: bold;
}
.cursor-help {
  cursor: help;
}
.thin-text {
  color: rgba(44, 50, 54, 0.7);
}
.display-flex {
  display: flex;
}
.flex-total-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.display-none {
  display: none;
}
.align-items-center {
  align-items: center;
}
.justify-content-space-between {
  justify-content: space-between;
}

.color-theme-dark {

  svg.calendar-icon {

    rect.svg-main, path.svg-spin {
      fill: #CFD0D1 !important;
    }
    rect.svg-date, path.svg-back {
      fill: #2C3236 !important;
    }
  }
  .thin-text {
    color: rgba(207, 208, 209, 0.7) !important;
  }

  .detailed:disabled {
    border-color: #5F6467;
    color: #5F6467 !important;
  }
  .detailed:disabled:hover {
    background: transparent !important;
    color: #5F6467 !important;
    border-color: #5F6467 !important;
  }

  .card {
    background: #2C3236 !important;
    color: #CFD0D1 !important;
    border: 1px solid #5F6467;

    svg.expand-icon path {
      fill: #CFD0D1 !important;
    }
  }

  ::placeholder {
    color: #CFD0D1;
  }
  :-ms-input-placeholder {
      color: #CFD0D1;
  }
  ::-ms-input-placeholder {
    color: #CFD0D1;
  }

  ::-webkit-scrollbar-track {
    background:transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #CFD0D1;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #888;
  }

  button.detailed {
    color: #CFD0D1 !important;
    text-decoration: none !important;
  }
}


.leadhit-ul {
  padding-left: 18px;
  list-style: none;

  li {
    margin-bottom: 10px;
  }
  li::before {
    content: "\2022";
    color: #FF4402;
    font-weight: 900;
    display: inline-block;
    width: 1rem;
    margin-left: -1rem;
    font-size: 16px;
  }
}

.underline-text {
  text-decoration: underline;
}

.custom-check-box {

  .custom-control-label {
    cursor: pointer;
    user-select: none;
  }
  .custom-control-label::before {
    border: 1px solid #2C3236;
    border-radius: 3px;
    background: transparent;
  }
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #2C3236;
  }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 0.2rem rgba(44, 50, 54, 0.25);
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #2C3236;
    background-color: transparent;
  }
  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    background-color: transparent;
    border-color: #2C3236;
  }
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjYgMjYiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIj48Zz48cGF0aCBkPSJtLjMsMTRjLTAuMi0wLjItMC4zLTAuNS0wLjMtMC43czAuMS0wLjUgMC4zLTAuN2wxLjQtMS40YzAuNC0wLjQgMS0wLjQgMS40LDBsLjEsLjEgNS41LDUuOWMwLjIsMC4yIDAuNSwwLjIgMC43LDBsMTMuNC0xMy45aDAuMXYtOC44ODE3OGUtMTZjMC40LTAuNCAxLTAuNCAxLjQsMGwxLjQsMS40YzAuNCwwLjQgMC40LDEgMCwxLjRsMCwwLTE2LDE2LjZjLTAuMiwwLjItMC40LDAuMy0wLjcsMC4zLTAuMywwLTAuNS0wLjEtMC43LTAuM2wtNy44LTguNC0uMi0uM3oiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6I0ZGNDQwMiIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiPjwvcGF0aD48L2c+IDwvc3ZnPg==");
  }
  .custom-control-input:disabled ~ .custom-control-label::before, .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background: transparent;
  }
  .custom-control-input:disabled ~ .custom-control-label {
    cursor: auto;
  }
}
.color-theme-dark {
  .custom-check-box {

    .custom-control-label::before {
      border: 1px solid #CFD0D1;
      border-radius: 3px;
      background-color: transparent;
    }
    .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
      border-color: #CFD0D1;
    }
    .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: 0 0 0 0.2rem rgba(207, 208, 209, 0.25);
    }
    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #CFD0D1;
      background-color: transparent;
    }
     .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
      background-color: transparent;
      border-color: #CFD0D1;
    }

  }
}

.spinner-border {
  color: #FF4402;
  width: 50px;
  height: 50px;
}

.resize-icon {
  position: absolute;
  bottom: 22px;
  right: 30px;
}
.resize-icon:hover path {
  fill: #FF4402;
  transition: .3s;
}

input::-webkit-credentials-auto-fill-button {
  margin: 0;
  width: 0;
  background-color: transparent;
}

.amcharts-Sprite-group.amcharts-Container-group.amcharts-AmChartsLogo-group {
  opacity: 0.1;
}


.disable-pointer-event-none {
  pointer-events: none !important;
}

.disable-cursor-not-allowed {
  cursor: not-allowed !important;
}

@media (max-width: 5000px) {
  .analytic-wrapper {
    width: 3230px;
  }
}
@media (max-width: 3354px) {
  .analytic-wrapper {
    width: 2822px;
  }
}
@media (max-width: 2947px) {
  .analytic-wrapper {
    width: 2415px;
  }
}
@media (max-width: 2540px) {
  .analytic-wrapper {
    width: 2008px;
  }
}
@media (max-width: 2140px) {
  .analytic-wrapper {
    width: 1601px;
  }
}
@media (max-width: 1741px) {
  .analytic-wrapper {
    width: 1194px;
  }
}
@media (max-width: 1334px) {
  .analytic-wrapper {
    width: 788px;
  }
}
@media (max-width: 927px) {
  .analytic-wrapper {
    width: 380px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue